import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fromages',
  templateUrl: './fromages.component.html',
  styleUrls: ['./fromages.component.scss']
})
export class FromagesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/menus/fromages/fromages.component.ts